import { ColorModeScript, type ThemeConfig } from "@chakra-ui/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import theme from "@/app/configs/theme";
import { App } from "./app";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ColorModeScript initialColorMode={(theme.config as ThemeConfig).initialColorMode} />
    <App />
  </StrictMode>,
);
